<template>
    <div class="section01">
        <h3>
            대기환경
            <button type="button" class="button-map-view" style="cursor: pointer;"
                @click.prevent="showAirMapWin(true)">지도로 보기</button>
        </h3>
        <div class="today-weather">
            현재 기온
            <span class="white">{{ airSpace.t1hValue }}℃ {{ airSpace.forecastText }}</span>
        </div>
        <div class="weather-box-wrap">
            <div class="box-wrap">
                <div class="weather-box">
                    <strong class="red">{{ airHjdAvg['pm10'] }}</strong> ㎍/㎥
                    <p>미세먼지</p>
                    <span :class="pm10LevelGrade[0]">{{ pm10LevelGrade[1] }}</span>
                </div>
                <div class="weather-box">
                    <strong class="yellow">{{ airHjdAvg['pm25'] }}</strong> ㎍/㎥
                    <p>초미세먼지</p>
                    <span :class="pm25LevelGrade[0]">{{ pm25LevelGrade[1] }}</span>
                </div>
                <div class="weather-box">
                    <strong>{{ airHjdAvg['no2'] }}</strong> ppm
                    <p>이산화질소</p>
                    <span :class="no2LevelGrade[0]">{{ no2LevelGrade[1] }}</span>
                </div>
                <div class="weather-box">
                    <strong>{{ airHjdAvg['o3'] }}</strong> ppm
                    <p>오존</p>
                    <span :class="o3LevelGrade[0]">{{ o3LevelGrade[1] }}</span>
                </div>
            </div>
        </div>

        <transition name="modal">
            <AirMapWin v-if="isShowAirMapWin" @close-air-map-win="showAirMapWin(false)" />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import airLevel from '@/lib/air.level';
import AirMapWin from "@/views/realtime/AirMapWin.vue"

export default {
    name: 'AirSummary',
    data() {
        return {
            isShowAirMapWin: false,
        }
    },
    computed: {
        ...mapGetters({
            airHjdAvg: 'getAirHjdAvg',
            airSpace: 'getAirSpace',
        }),
        pm10LevelGrade() {
            return airLevel.pm10Level(this.airHjdAvg['pm10']);
        },
        pm25LevelGrade() {
            return airLevel.pm25Level(this.airHjdAvg['pm25']);
        },
        no2LevelGrade() {
            return airLevel.no2Level(this.airHjdAvg['no2']);
        },
        o3LevelGrade() {
            return airLevel.o3Level(this.airHjdAvg['o3']);
        },
    },
    methods: {
        showAirMapWin(isShow) {
            this.isShowAirMapWin = isShow;
        }
    },
    components: {
        AirMapWin,
    },
}
</script>
